import * as angular from 'angular';

import { PrintHelper } from './print.helper';
import { AlarmHelper } from './alarm.helper';
import { LogbookEntryHelper } from './logbookEntry.helper';
import { 
    dateAlignmentHelperId, dateAlignmentHelperInjector, DayAlignmentStrategy, HourAlignmentStrategy, IDateAlignmentHelper, 
    MinuteAlignmentStrategy, MonthAlignmentStrategy, WeekAlignmentStrategy, YearAlignmentStrategy
} from './dateAlignment';

export const helperModule = 'wt-helpers';
angular.module(helperModule, [])
    .service(PrintHelper.helperId, PrintHelper)
    .service(AlarmHelper.helperId, AlarmHelper)
    .service(LogbookEntryHelper.helperId, LogbookEntryHelper)
    .factory(dateAlignmentHelperId, dateAlignmentHelperInjector)
    .run([
        'dateAlignmentHelper', (dateAlignmentHelper: IDateAlignmentHelper) => {
            dateAlignmentHelper.registerStrategy(new YearAlignmentStrategy());
            dateAlignmentHelper.registerStrategy(new WeekAlignmentStrategy());
            dateAlignmentHelper.registerStrategy(new DayAlignmentStrategy());
            dateAlignmentHelper.registerStrategy(new HourAlignmentStrategy());
            dateAlignmentHelper.registerStrategy(new MinuteAlignmentStrategy());
            dateAlignmentHelper.registerStrategy(new MonthAlignmentStrategy());
    }]);